<template>
  <div class="user-list">
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="handleSearch">
        <el-form-item label="账号状态">
          <el-select v-model="searchForm.accountStatus" placeholder="全部" clearable style="width: 130px">
            <el-option label="正常" :value="1"></el-option>
            <el-option label="封禁中" :value="2"></el-option>
            <el-option label="已注销" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input
            v-model="searchForm.keyword"
            placeholder="昵称/OpenID"
            clearable
            style="width: 200px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>

        <el-form-item label="姓名">
          <el-input
              v-model="searchForm.realName"
              placeholder="姓名"
              clearable
              style="width: 200px"
              @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" v-loading="loading" stripe border>
        <el-table-column prop="id" label="用户ID" width="90" align="center"></el-table-column>
        <el-table-column label="头像" width="70" align="center">
          <template slot-scope="{ row }">
            <el-avatar :size="36" :src="row.avatarUrl" icon="el-icon-user-solid"></el-avatar>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" min-width="130"></el-table-column>
        <el-table-column prop="realName" label="姓名" min-width="130"></el-table-column>
        <el-table-column prop="communityName" label="社区" min-width="130"></el-table-column>
        <el-table-column label="认证状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="verifyStatusType(row.verifyStatus)" size="small">
              {{ verifyStatusText(row.verifyStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusType(row.accountStatus)" size="small">
              {{ statusText(row.accountStatus) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="totalOrders" label="累计核销" width="90" align="center"></el-table-column>
        <el-table-column prop="monthlyOrders" label="本月核销" width="90" align="center"></el-table-column>
        <el-table-column prop="violationCount" label="违规次数" width="90" align="center">
          <template slot-scope="{ row }">
            <span :style="{ color: row.violationCount > 0 ? '#F56C6C' : '' }">
              {{ row.violationCount || 0 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="最近登录" width="170">
          <template slot-scope="{ row }">
            {{ formatTime(row.lastLoginTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="banReason" label="封禁原因" min-width="130"></el-table-column>
        <el-table-column prop="banStartTime" label="封禁开始时间" min-width="130"></el-table-column>
        <el-table-column prop="banEndTime" label="封禁结束时间" min-width="130"></el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.accountStatus !== 2"
              size="mini"
              type="warning"
              @click="openBanDialog(row)"
            >封禁</el-button>
            <el-button
              v-if="row.accountStatus === 2"
              size="mini"
              type="success"
              @click="handleUnban(row)"
            >解封</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      ></el-pagination>
    </el-card>

    <!-- 封禁弹窗 -->
    <el-dialog title="封禁用户" :visible.sync="banVisible" width="450px">
      <el-form ref="banForm" :model="banForm" :rules="banRules" label-width="100px">
        <el-form-item label="封禁原因" prop="reason">
          <el-input v-model="banForm.reason" type="textarea" :rows="3" placeholder="请输入封禁原因"></el-input>
        </el-form-item>
        <el-form-item label="封禁天数">
          <el-input-number v-model="banForm.days" :min="1" :max="365" placeholder="留空为永久"></el-input-number>
          <span style="margin-left:8px;color:#909399;font-size:12px;">天（不填则永久封禁）</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="banVisible = false">取 消</el-button>
        <el-button type="danger" :loading="submitting" @click="doBan">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, banUser, unbanUser } from '@/api/user'

export default {
  name: 'UserList',
  data() {
    return {
      searchForm: { keyword: '', realName: '' , accountStatus: '' },
      tableData: [],
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      banVisible: false,
      banForm: { id: null, reason: '', days: null },
      banRules: {
        reason: [{ required: true, message: '请输入封禁原因', trigger: 'blur' }]
      },
      submitting: false
    }
  },
  mounted() { this.loadData() },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await getUserList(this.searchForm.keyword, this.searchForm.realName, this.searchForm.accountStatus, this.page, this.size)
        const list = res.records || res.list || res.items || res || []
        this.tableData = Array.isArray(list) ? list : []
        this.total = res.total || this.tableData.length
      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.page = 1; this.loadData() },
    resetSearch() { this.searchForm = { keyword: '', realName: '', accountStatus: '' }; this.page = 1; this.loadData() },
    handleSizeChange(val) { this.size = val; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },
    statusType(s) { return s === 1 ? 'success' : s === 2 ? 'danger' : 'info' },
    statusText(s) { return s === 1 ? '正常' : s === 2 ? '封禁中' : '已注销' },
    // 认证状态映射
    verifyStatusType(s) {
      // null / undefined → 未认证
      if (s === null || s === undefined) return 'info'
      // 1 已认证
      if (s === 1) return 'success'
      // 2 未通过
      if (s === 2) return 'danger'
      // 0 待审核
      if (s === 0) return 'warning'
      // 3 已过期
      if (s === 3) return 'info'
      return 'info'
    },

    verifyStatusText(s) {
      if (s === null || s === undefined) return '未认证'
      if (s === 0) return '待审核'
      if (s === 1) return '已认证'
      if (s === 2) return '未通过'
      if (s === 3) return '已过期'
      return '未知状态'
    },
    openBanDialog(row) {
      this.banForm = { id: row.id, reason: '', days: null }
      this.banVisible = true
    },
    doBan() {
      this.$refs.banForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await banUser(this.banForm.id, this.banForm.reason, this.banForm.days)
          this.$message.success('已封禁')
          this.banVisible = false
          this.loadData()
        } catch (e) {} finally {
          this.submitting = false
        }
      })
    },
    async handleUnban(row) {
      try {
        await unbanUser(row.id)
        this.$message.success('已解封')
        this.loadData()
      } catch (e) {}
    },
    formatTime(t) { return t ? new Date(t).toLocaleString('zh-CN', { hour12: false }) : '-' }
  }
}
</script>

<style scoped>
.user-list { padding: 0; }
.search-card { margin-bottom: 16px; border-radius: 8px; }
.table-card { border-radius: 8px; }
.pagination { margin-top: 16px; text-align: right; }
</style>
